// Placeholder-first shared state: `utils/GooglePay` writes on tap,
// `utils/GooglePayHandlers` reads inside the INITIALIZE callback. Extracted
// here to avoid a cyclic import — GooglePay already imports GooglePayHandlers,
// so a direct back-reference would set up a load-order trap.

/**
 * @typedef {Object} PendingInitParams
 * @property {string} transactionAmount - merchandise subtotal (pre-tax)
 * @property {string} transactionCurrencyCode - ISO 4217
 * @property {boolean} isBopis
 * @property {boolean} isSdd
 */

let pendingInit = null;

/**
 * Stashes tap-time init params so the paysheet's INITIALIZE callback can
 * consume them off-thread. Called synchronously from the click handler.
 *
 * @param {PendingInitParams} params
 */
export function setPendingInit(params) {
    pendingInit = params;
}

/**
 * Resets the pending state. Called in two places:
 *   1. `runPendingCheckoutInit` right after reading (consume-once semantics
 *      so repeat INITIALIZE callbacks fall through to the address-change
 *      path instead of re-running the init chain).
 *   2. `openPaysheetInitOnDemand`'s `.finally` so a bailout that never
 *      reached INITIALIZE (e.g., loadPaymentData rejection before the sheet
 *      opens) still clears the stash.
 */
export function clearPendingInit() {
    pendingInit = null;
}

/**
 * @returns {PendingInitParams | null}
 */
export function getPendingInit() {
    return pendingInit;
}

/**
 * @returns {boolean}
 */
export function hasPendingInit() {
    return pendingInit !== null;
}
